import React, { useState } from "react";
import { Modal, Table, ProgressBar, Button, Row, Col, Card, Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import LeaveModal from "./Modal/LeaveModal";
import ApprovalModal from "./Modal/ApprovalModal";

const MonthlyCalendar = ({ year, month, tasks, employeeId, employees, onLeaveApplied }) => {

  const userState = useSelector((state) => state.loginData.userData);

  const daysInMonth = new Date(year, month, 0).getDate();
  const firstDay = new Date(year, month - 1, 1).getDay();

  // State for the selected date
  const [selectedDate, setSelectedDate] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showLeaveModal, setShowLeaveModal] = useState(false);
  const [leaveDate, setLeaveDate] = useState(null);

  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [selectedEmployeeData, setSelectedEmployeeData] = useState(null);

  // Initialize an empty array for the calendar
  const calendarDays = Array(firstDay).fill(null);
  for (let i = 1; i <= daysInMonth; i++) {
    const formattedDate = `${year}-${String(month).padStart(2, "0")}-${String(i).padStart(2, "0")}`;
    const task = tasks.find((t) => t._id?.endDate === formattedDate);
    calendarDays.push({
      date: i,
      statuses: task?.statuses || [],
      tasks: task?.tasks || [],
      leaveStatus: task?.leaveStatus?.trim()
    });
  }

  // for handler right click
  const handleRightClick = async (e, day) => {
    e.preventDefault();

    if (!day) return;

    const formattedDate = `${year}-${String(month).padStart(2, "0")}-${String(day.date).padStart(2, "0")}`;
    const clickedDate = new Date(year, month - 1, day.date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (userState?.resourceType === "employee") {
      if (clickedDate < today) {
        return;
      }

      try {
        const response = await fetch(process.env.REACT_APP_BASE_URL + "/leave/getAllleavePGN", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            empId: userState?.empId,
            workEmail: "",
            leaveType: ""
          }),
        });

        const data = await response.json();

        const selectedLeave = data?.responses?.data?.find((leave) => {
          const from = new Date(leave.fromDate);
          const to = new Date(leave.toDate);
          const selected = new Date(formattedDate);

          from.setHours(0, 0, 0, 0);
          to.setHours(0, 0, 0, 0);
          selected.setHours(0, 0, 0, 0);

          return selected >= from && selected <= to;
        });

        setLeaveDate({
          ...day,
          fullDate: formattedDate,
          leaveInfo: selectedLeave || null
        });

        setShowLeaveModal(true);

      } catch (error) {
        console.error(error);
      }

      return;
    }

    if (userState?.resourceType === "teamlead") {
      // if (!employeeId) {
      //   alert("Please select employee first");
      //   return;
      // }
      try {
        const response = await fetch(process.env.REACT_APP_BASE_URL + "/leave/getAllleavePGN", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            empId: employeeId,
            workEmail: "",
            leaveType: ""
          }),
        });

        const data = await response.json();
        const selectedLeave = data?.responses?.data?.filter((leave) => {
          const from = new Date(leave.fromDate);
          const to = new Date(leave.toDate);
          const selected = new Date(formattedDate);

          from.setHours(0, 0, 0, 0);
          to.setHours(0, 0, 0, 0);
          selected.setHours(0, 0, 0, 0);

          return selected >= from && selected <= to;
        });

        setSelectedEmployeeData({
          date: formattedDate,
          leaveData: selectedLeave,
          empId: employeeId,
          empName: employees?.find(e => e.value === employeeId)?.label || ""
        });
        setShowApprovalModal(true);

      } catch (error) {
        console.error("Error fetching leave data", error);
      }
    }
  };

  // Add padding at the end to complete the last week
  while (calendarDays.length % 7 !== 0) {
    calendarDays.push(null);
  }

  // Create rows for each week
  const weeks = [];
  for (let i = 0; i < calendarDays.length; i += 7) {
    weeks.push(calendarDays.slice(i, i + 7));
  }

  const handleDayClick = (day) => {
    if (day && day.tasks.length > 0) {
      setSelectedDate(day);
      setShowModal(true);
    }
  };

  const getDayStyle = (day) => {
    if (!day) {
      return {
        backgroundColor: "transparent",
        color: "black",
        cursor: "default",
      };
    }
    if (day.leaveStatus?.trim() === "On Leave") {
      return {
        backgroundColor: "yellow",
        color: "black",
        cursor: "pointer",
        fontWeight: "bold"
      };
    }

    if (day.tasks.length === 0) {
      return {
        backgroundColor: "white",
        color: "black",
        cursor: "default",
      };
    }

    const statuses = day.statuses;
    if (statuses.includes("pending")) {
      return {
        backgroundColor: "red",
        color: "white",
        cursor: "pointer",
      };
    }

    if (statuses.includes("completed")) {
      return {
        backgroundColor: "green",
        color: "white",
        cursor: "pointer",
      };
    }

    return {
      backgroundColor: "white",
      color: "black",
      cursor: "default",
    };
  };


  // Calculate completed compliance
  const completedDays = calendarDays.filter((day) => {
    return (
      day &&
      day.tasks.length > 0 &&
      !day.statuses.includes('pending')
    );
  }).length;

  const compliancePercentage = Math.floor((completedDays / daysInMonth) * 100);

  return (
    <div className="Calender">

      <Table bordered responsive>
        <thead>
          <tr>
            <th>Sun</th>
            <th>Mon</th>
            <th>Tue</th>
            <th>Wed</th>
            <th>Thu</th>
            <th>Fri</th>
            <th>Sat</th>
          </tr>
        </thead>
        <tbody>
          {weeks.map((week, index) => (
            <tr key={index}>
              {week.map((day, idx) => (
                <td
                  key={idx}
                  onClick={() => day && handleDayClick(day)}
                  onContextMenu={(e) => handleRightClick(e, day)}
                  style={{
                    ...getDayStyle(day),
                    textAlign: "center",
                  }}
                >
                  {day ? (
                    <>
                      <div>{day.date}</div>

                      {day.leaveStatus === "On Leave" && (
                        <div style={{
                          fontSize: "10px",
                          color: "black",
                          fontWeight: "bold"
                        }}>
                          Leave
                        </div>
                      )}
                    </>
                  ) : ""}
                  {/* {day ? day.date : ""} */}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>



      {/* Progress Bars */}
      <div className="mt-3">
        <Row className="justify-content-center">
          <Col md={12}>
            <p>Overall Compliance: {completedDays}/{daysInMonth} Days </p>
            <ProgressBar
              animated
              now={compliancePercentage}
              label={`${compliancePercentage}%`}
              variant="primary"
            />
          </Col>
        </Row>
      </div>


      {/* Modal for Task Details */}
      <Modal size="lg" show={showModal} onHide={() => setShowModal(false)} >
        <Modal.Header closeButton>
          <Modal.Title>Task Details for {selectedDate?.date}-{month}-{year}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-4 pb-2">
          {selectedDate?.tasks?.length > 0 ? (
            <>
              {selectedDate.tasks.map((task, idx) => (
                <Card key={idx} id="TaskList" className={`${task.status === "pending" ? "border border-danger" : "border border-success"} mb-4`}>
                  <Card.Header className="d-flex justify-content-between align-items-center gap-3">
                    <p className="mb-0">{task.taskName} </p>
                    <p className={`${task.status} mb-0`}>{task.status}</p></Card.Header>
                  <Card.Body>
                    <div className="mb-2">
                      <p className="label">Project</p>
                      <p className="value">{task.projectName}</p>
                    </div>

                    <div className="mb-2">
                      <p className="label">Category</p>
                      <p className="value">{task.categoryOfName ? task.categoryOfName : "-"}</p>
                    </div>

                    <div className="mb-2">
                      <p className="label">Priority</p>
                      <p className="value">{task.taskPriority}</p>
                    </div>

                    <div className="mb-2">
                      <p className="label">proposedStartDate</p>
                      <p className="value">{task.proposedStartDate}</p>
                    </div>

                    <div className="mb-2">
                      <p className="label">proposedEndDate</p>
                      <p className="value">{task.proposedEndDate}</p>
                    </div>


                  </Card.Body>
                </Card>
              ))}
            </>
          ) : (
            <p>No tasks for this date.</p>
          )}
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer> */}
      </Modal>

      {/* modal for leave apply */}
      <LeaveModal
        show={showLeaveModal}
        onHide={() => setShowLeaveModal(false)}
        leaveDate={leaveDate}
        month={month}
        year={year}
        userState={userState}
        onSuccess={onLeaveApplied}
      />

      {/* modal for approval/reject */}
      <ApprovalModal
        show={showApprovalModal}
        onHide={() => setShowApprovalModal(false)}
        selectedData={selectedEmployeeData}
        month={month}
        year={year}
        userData={userState}
      />

    </div>
  );
};

export default MonthlyCalendar;




